<input type="text"
       name="daterangeInput"
       ccInput
       class="date-picker form-control"
       daterangepicker
       [options]="pickerOptions"
       [id]="inputId"
       (selected)="selectedDate($event)"/>
<label class="input-group-addon" [for]="inputId"><i
  class="material-icons">today</i></label>
